import './App.css';
import {AppRouter} from "./router/App.router";

function App() {
    return (
        <>
            <AppRouter/>
        </>
    );
}

export default App;
